import React from 'react'

function Success() {
    return (
        <div className='success-container space-top pb-3'>
            <img className='green-tick' src='/images/green-tick.png' />
            <h2> Form Successfully Submitted!</h2>
        </div>
    )
}

export default Success
